import { SVGProps } from 'react'

import cl from '@/screensComponents/Form/FormStatus/FormStatus.module.scss'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { Button } from '@/shared/ui'
import { IconTemplate } from '@/shared/ui/icon-template/icon-template'

import styles from './FormSuccessMessage.module.scss'

type FormSuccessMessageProps = {
	onOk?: () => void
	title?: string
	subtitle?: string
	okButtonText?: string
}

interface CustomIconProps {
	title?: string
	size?: number
}

/**
 * Success form request message
 * @param title
 * @param subtitle
 * @param okButtonText
 * @param onOk
 */
export const FormSuccessMessage = ({
	title = ``,
	subtitle = `Перезвоним в течение 30 минут для подтверждения заказа`,
	okButtonText = `Закрыть`,
	onOk
}: FormSuccessMessageProps): JSX.Element => (
	<section className={styles.formSuccessMessage}>
		<div className={styles.iconWrap}>
			<SvgStatusOk height={48} width={48} viewBox={'0 0 48 48'} className={cl.formStatus__icon} />
		</div>

		<h3 className={styles.title}>{title}</h3>

		<p className={styles.subtitle} dangerouslySetInnerHTML={createMarkup(subtitle)} />

		{!!onOk && (
			<Button className={styles.buttonClose} onClick={onOk} theme="primary">
				{okButtonText}
			</Button>
		)}
	</section>
)

export const SvgStatusOk = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplate {...props}>
			<svg fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_18313_43755)">
					<path
						d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
						fill="#568DFE"
					/>
					<path
						d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
						fill="url(#paint0_linear_18313_43755)"
					/>
					<path
						d="M35.2953 15.5293L20.3098 31.8461L12.707 23.9999"
						stroke="white"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
				<defs>
					<linearGradient
						id="paint0_linear_18313_43755"
						x1="51.6"
						y1="52.3636"
						x2="-3.3467e-06"
						y2="27.6923"
						gradientUnits="userSpaceOnUse">
						<stop stopColor="#E4EDFC" />
						<stop offset="1" stopColor="#568DFE" />
					</linearGradient>
					<clipPath id="clip0_18313_43755">
						<rect width="48" height="48" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</IconTemplate>
	)
}
